/* @flow */

import type {MentionConfig} from 'shells/rich-textarea';

import {getEntities} from './mentions-utils';

export function getMentionsConfig(): MentionConfig {
    return {
        enabled: true,
        getMentions: (searchTerm: string) => {
            return getEntities(searchTerm).then((response) => {
                return {matches: response};
            });
        },
    };
}
